import { Filter, SortDirections, SortPayload } from "@/types/ApiResponse";

export function serializeSortToUrl(sort: SortPayload | null): string | null {
  if (!sort) return null;
  return `key:${sort.key};direction:${sort.direction}`;
}

export function parseSortFromUrl(param: string | null): SortPayload | null {
  if (!param) return null;
  const parts = Object.fromEntries(
    param.split(";").map((part) => {
      const [key, value] = part.split(":");
      return [key, decodeURIComponent(value)];
    })
  );
  return parts.key && parts.direction
    ? {
        key: parts.key,
        direction: parts.direction as SortDirections,
      }
    : null;
}

export function serializeFiltersToUrl(filters: Filter[]): string {
  return filters
    .map((f) => {
      const parts = [`key:${f.key}`, `operateur:${f.operateur}`];
      if (f.value !== undefined)
        parts.push(`value:${encodeURIComponent(f.value.toString())}`);
      if (f.valueMin !== undefined)
        parts.push(`valueMin:${encodeURIComponent(f.valueMin.toString())}`);
      if (f.valueMax !== undefined)
        parts.push(`valueMax:${encodeURIComponent(f.valueMax.toString())}`);
      if (f.valueIn && f.valueIn.length > 0)
        parts.push(`valueIn:${f.valueIn.map(encodeURIComponent).join(",")}`);
      return parts.join(";");
    })
    .join("|");
}

export function parseFiltersFromUrl(param: string): Filter[] {
  if (!param) return [];

  return param.split("|").map((filterStr) => {
    const parts = filterStr.split(";").reduce((acc, part) => {
      const [key, value] = part.split(":");
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {} as Record<string, string>);

    const filter: Filter = {
      key: parts.key,
      operateur: parts.operateur,
    };

    if (parts.value) filter.value = parts.value;
    if (parts.valueMin) {
      // @ts-ignore
      filter.valueMin = parts.valueMin;
    }
    if (parts.valueMax) {
      // @ts-ignore
      filter.valueMax = parts.valueMax;
    }
    /*if (parts.valueMin)
      filter.valueMin = isNaN(Date.parse(parts.valueMin))
        ? Number(parts.valueMin)
        : new Date(parts.valueMin);
    if (parts.valueMax)
      filter.valueMax = isNaN(Date.parse(parts.valueMax))
        ? Number(parts.valueMax)
        : new Date(parts.valueMax);*/
    if (parts.valueIn)
      filter.valueIn = parts.valueIn.split(",").map(decodeURIComponent);

    return filter;
  });
}
